const FilmCriticisma = () => (
  <h1>Film Criticisma</h1>
);

export default FilmCriticisma;
